











































	import Vue, { PropType } from 'vue';
    import _moderation from '../../services/endpoints/moderation';
	import { UserRole } from '../../../../models/Enums'
	import { Spieler } from 'models/Spieler';

    export default Vue.extend({
        name: "ModListUserEditRoleComp",
		props: {
			user: Object as PropType<Spieler>,
		},
        data: () => ({
			role: UserRole.Normal
        }),
		computed: {
			disabled: function(): boolean {
				return this.$vStore.getters.loggedInUser.role <= UserRole.Maz;
			}
		},
        methods: {
			change: async function(): Promise<void> {
				await _moderation.updateSpielerRole(this.user.id, this.role);
			}
        },
        created: async function (): Promise<void> {
			this.role = this.user.role;
        }
    })
